export class Dict<K,V> {
    map = {}

    constructor(obj?: {}) { 
        this.map = obj ?? {}
    }

    hashFunction = (key:K) => JSON.stringify(key)

    undoHashFunction = (keyStr:string) => JSON.parse(keyStr)

    formatKey = (key:K) => JSON.stringify(key,null,2)

    set(key:K, value:V) {
        this.map[this.hashFunction(key)] = value

        return this
    }

    has(key:K) {
        return this.hashFunction(key) in this.map
    }

    get(key:K) : V {
        return this.map[this.hashFunction(key)]
    }

    remove(key:K) {
        delete this.map[this.hashFunction(key)]

        return this
    }

    keys () : K[] {
        return Object.keys(this.map).map(this.undoHashFunction)
    }

    keysValues() {
        return Object.values(this.map)
    }

    toString() {
        let str = ""

        for (let keyStr in this.map) {
            str += `key: ${this.formatKey(this.undoHashFunction(keyStr))}\n value: ${this.map[keyStr]}\n\n`    
        }

        return str == "" ? "{}" : str
    }

    keysToList() {
        let list = []

        for (let keyStr in this.map) {
            list = list.concat(this.undoHashFunction(keyStr))
        }
        return list
    }
}